"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseCountries = require("nicbase-countries");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

var _yup = require("yup");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var schema = (0, _yup.object)().shape({
  companyName: (0, _yup.string)().min(1).max(256).required(),
  address: (0, _yup.object)().shape({
    street: (0, _yup.string)().min(1).max(40).required(),
    countryCode: (0, _yup.string)().min(1).max(2).required(),
    number: (0, _yup.string)().min(1).max(9).required(),
    postalCode: (0, _yup.string)().min(1).max(16).required(),
    city: (0, _yup.string)().min(1).max(35).required()
  })
}); // Tax ID label configuration for countries that bypass EU VAT validation.
// Maps country code to a translation key prefix and label key.

var NON_EU_TAX_ID_CONFIG = {
  // North America (NPI-278)
  US: {
    prefix: 'dotCheck',
    label: 'dot'
  },
  CA: {
    prefix: 'mcCheck',
    label: 'mc'
  },
  // Latin America & Caribbean (NPI-2756)
  MX: {
    prefix: 'rfcCheck',
    label: 'rfc'
  },
  BR: {
    prefix: 'cnpjCheck',
    label: 'cnpj'
  },
  AR: {
    prefix: 'cuitCheck',
    label: 'cuit'
  },
  CL: {
    prefix: 'rutCheck',
    label: 'rut'
  },
  UY: {
    prefix: 'rutCheck',
    label: 'rut'
  },
  CO: {
    prefix: 'nitCheck',
    label: 'nit'
  },
  GT: {
    prefix: 'nitCheck',
    label: 'nit'
  },
  SV: {
    prefix: 'nitCheck',
    label: 'nit'
  },
  BO: {
    prefix: 'nitCheck',
    label: 'nit'
  },
  CU: {
    prefix: 'nitCheck',
    label: 'nit'
  },
  PE: {
    prefix: 'rucCheck',
    label: 'ruc'
  },
  EC: {
    prefix: 'rucCheck',
    label: 'ruc'
  },
  NI: {
    prefix: 'rucCheck',
    label: 'ruc'
  },
  PA: {
    prefix: 'rucCheck',
    label: 'ruc'
  },
  PY: {
    prefix: 'rucCheck',
    label: 'ruc'
  },
  CR: {
    prefix: 'cedulaCheck',
    label: 'cedula'
  },
  HN: {
    prefix: 'rtnCheck',
    label: 'rtn'
  },
  DO: {
    prefix: 'rncCheck',
    label: 'rnc'
  },
  PR: {
    prefix: 'dotCheck',
    label: 'dot'
  },
  VI: {
    prefix: 'dotCheck',
    label: 'dot'
  },
  TT: {
    prefix: 'birCheck',
    label: 'bir'
  },
  JM: {
    prefix: 'trnCheck',
    label: 'trn'
  },
  VE: {
    prefix: 'rifCheck',
    label: 'rif'
  },
  HT: {
    prefix: 'nifCheck',
    label: 'nif'
  },
  GY: {
    prefix: 'tinCheck',
    label: 'tin'
  },
  BB: {
    prefix: 'tinCheck',
    label: 'tin'
  },
  SR: {
    prefix: 'tinCheck',
    label: 'tin'
  },
  LC: {
    prefix: 'tinCheck',
    label: 'tin'
  },
  AG: {
    prefix: 'tinCheck',
    label: 'tin'
  },
  BZ: {
    prefix: 'tinCheck',
    label: 'tin'
  },
  GD: {
    prefix: 'tinCheck',
    label: 'tin'
  },
  KN: {
    prefix: 'tinCheck',
    label: 'tin'
  },
  DM: {
    prefix: 'tinCheck',
    label: 'tin'
  },
  VC: {
    prefix: 'tinCheck',
    label: 'tin'
  },
  BS: {
    prefix: 'businessLicenseCheck',
    label: 'businessLicense'
  },
  TC: {
    prefix: 'businessLicenseCheck',
    label: 'businessLicense'
  },
  AI: {
    prefix: 'businessLicenseCheck',
    label: 'businessLicense'
  },
  AW: {
    prefix: 'cribCheck',
    label: 'crib'
  },
  KY: {
    prefix: 'businessRegCheck',
    label: 'businessReg'
  },
  GF: {
    prefix: 'siretCheck',
    label: 'siret'
  },
  MQ: {
    prefix: 'siretCheck',
    label: 'siret'
  },
  GP: {
    prefix: 'siretCheck',
    label: 'siret'
  },
  MF: {
    prefix: 'siretCheck',
    label: 'siret'
  },
  VG: {
    prefix: 'companyRegCheck',
    label: 'companyReg'
  }
};

var AddressForm = function AddressForm(_ref) {
  var intl = _ref.intl,
      onNextClick = _ref.onNextClick,
      infos = _ref.infos;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isValid = _useState2[0],
      setIsValid = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isEmpty = _useState4[0],
      setIsEmpty = _useState4[1];

  var _useState5 = (0, _react.useState)({
    address: {
      street: '',
      countryCode: 'DE',
      number: '',
      postalCode: '',
      city: ''
    },
    name: '',
    companyName: '',
    vat: '',
    vatAlreadyExists: false,
    valid: false,
    vatOwner: ''
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      inputs = _useState6[0],
      setInputs = _useState6[1];

  var _useState7 = (0, _react.useState)(''),
      _useState8 = _slicedToArray(_useState7, 2),
      label = _useState8[0],
      setLabel = _useState8[1];

  (0, _react.useEffect)(function () {
    var config = NON_EU_TAX_ID_CONFIG[inputs.address.countryCode];

    if (config) {
      setLabel( /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "portal.registration.".concat(config.prefix, ".").concat(config.label)
      }));
    } else {
      setLabel( /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "portal.registration.adress.vat"
      }));
    }
  }, [inputs.address.countryCode]);
  var firstUpdate = (0, _react.useRef)(true);
  (0, _react.useEffect)(function () {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      setInputs(_objectSpread(_objectSpread({}, inputs), {}, {
        companyName: infos.companyName === null ? '' : infos.companyName,
        vat: infos.vat,
        address: {
          countryCode: infos.address.countryCode,
          street: '',
          number: '',
          postalCode: '',
          city: ''
        }
      }));
    }

    try {
      if (schema.validateSync(infos)) {
        setIsEmpty(false);
      }
    } catch (e) {
      setIsEmpty(true);
    }

    try {
      if (schema.validateSync(inputs)) {
        setIsValid(true);
      }
    } catch (e) {
      setIsValid(false);
    }
  }, [inputs, infos, isValid, isEmpty]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex bg-cyan-500 justify-around items-center h-full w-full text-primary"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "sm:w-1/2 lg:w-1/3 xl:w-1/4 bg-white pt-5 pl-12 pr-12 pb-5 flex flex-col text-base rounded"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicplaceLogo, {
    height: "90",
    width: "280",
    className: "self-center mb-10"
  }), isEmpty ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.adress.header.left.start.empty"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-bold mx-1 mb-5"
    }, value);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.adress.header.left.middle.empty"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "mx-1"
    }, value);
  })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.adress.header.left.start"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-bold mx-1 mb-5"
    }, value);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.adress.header.left.middle"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "mx-1"
    }, value);
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    disabled: true,
    value: intl.formatMessage({
      id: _nicbaseCountries.CountryCodeMapping[inputs.address.countryCode]
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "portal.registration.adress.country",
      tagName: "span"
    }),
    className: "mt-5"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-row"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    disabled: true,
    value: inputs.vat,
    label: label,
    className: "flex-1",
    tagName: "span"
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    value: inputs.companyName,
    onChange: function onChange(e) {
      return setInputs(_objectSpread(_objectSpread({}, inputs), {}, {
        companyName: e
      }));
    },
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "portal.registration.adress.company",
      tagName: "span"
    }),
    className: "mt-10",
    maxLength: 256
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-between"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    value: inputs.address.street,
    onChange: function onChange(e) {
      return setInputs(_objectSpread(_objectSpread({}, inputs), {}, {
        address: _objectSpread(_objectSpread({}, inputs.address), {}, {
          street: e
        })
      }));
    },
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "portal.registration.adress.street.name",
      tagName: "span"
    }),
    className: "w-8/12 mr-5",
    maxLength: 40
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    value: inputs.address.number,
    onChange: function onChange(e) {
      return setInputs(_objectSpread(_objectSpread({}, inputs), {}, {
        address: _objectSpread(_objectSpread({}, inputs.address), {}, {
          number: e
        })
      }));
    },
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "portal.registration.adress.street.number",
      tagName: "span"
    }),
    className: "w-4/12",
    maxLength: 9
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-between"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    value: inputs.address.postalCode,
    onChange: function onChange(e) {
      return setInputs(_objectSpread(_objectSpread({}, inputs), {}, {
        address: _objectSpread(_objectSpread({}, inputs.address), {}, {
          postalCode: e
        })
      }));
    },
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "portal.registration.adress.postalCode",
      tagName: "span"
    }),
    className: "w-4/12 mr-5",
    maxLength: 16
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    value: inputs.address.city,
    onChange: function onChange(e) {
      return setInputs(_objectSpread(_objectSpread({}, inputs), {}, {
        address: _objectSpread(_objectSpread({}, inputs.address), {}, {
          city: e
        })
      }));
    },
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "portal.registration.adress.city"
    }),
    className: "w-8/12",
    maxLength: 35
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    disabled: !isValid,
    onClick: (0, _react.useCallback)(function () {
      onNextClick({
        address: inputs.address,
        vat: inputs.vat,
        name: inputs.companyName,
        companyName: inputs.companyName
      });
    }, [inputs, onNextClick]),
    className: "mt-10 self-center",
    primary: true,
    raised: true,
    name: "confirmClick"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.adress.button"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hidden sm:block w-2/5 text-base text-white font-bold"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.adress.header.right"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("h3", {
      className: "uppercase text-4xl mb-8"
    }, value);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.adress.text.right"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("h4", {
      className: "text-xl mb-8"
    }, value);
  })));
};

var noop = function noop() {};

AddressForm.propTypes = {
  intl: _nicbaseTranslation.intlShape.isRequired,
  onNextClick: _propTypes["default"].func,
  infos: _propTypes["default"].shape({
    address: _propTypes["default"].shape({
      countryCode: _propTypes["default"].string,
      street: _propTypes["default"].string,
      number: _propTypes["default"].string,
      postalCode: _propTypes["default"].string,
      city: _propTypes["default"].string
    }),
    valid: _propTypes["default"].bool,
    vatAlreadyExists: _propTypes["default"].bool,
    vat: _propTypes["default"].string,
    companyName: _propTypes["default"].string,
    vatOwner: _propTypes["default"].bool,
    name: _propTypes["default"].string
  })
};
AddressForm.defaultProps = {
  onNextClick: noop,
  infos: {
    address: {
      countryCode: '',
      street: '',
      number: '',
      postalCode: '',
      city: ''
    },
    vat: '',
    valid: false,
    vatAlreadyExists: false,
    companyName: '',
    vatOwner: '',
    name: ''
  }
};

var _default = (0, _nicbaseTranslation.injectIntl)(AddressForm);

exports["default"] = _default;